












































































































































import { Component, Vue } from "vue-property-decorator";
import { UserGroup } from "@/services/users/types";
import { getAllUserGroups } from "@/services/users/userGroupService";
import { userGroupFields } from "@/components/users/fields/userGroupsFields";
import UserGroupDeleteModal from "@/components/users/modals/UserGroupDeleteModal.vue";
@Component({
    components: { UserGroupDeleteModal }
})
export default class Groups extends Vue {
    // Local state
    groups = [] as Array<UserGroup>;
    isBusy = false;
    fields = userGroupFields;
    sortBy = "name";
    sortDesc = false;

    // filter options
    searchQuery = "";

    // lifecycle hooks

    public created() {
        this.fetchData();
    }

    // computed
    get filteredData() {
        return this.groups && this.groups
            .filter(x => this.searchQuery.length === 0 ||
                (x.name.toLowerCase().includes(this.searchQuery.toLowerCase()) ||
                    x.description.toLowerCase().includes(this.searchQuery.toLowerCase())));
    }
    // methods

    deleteUserGroup(groupId: string) {
        (this.$refs.userGroupDeleteModal as any).open(groupId);
    }

    fetchData() {
        this.isBusy = true;
        getAllUserGroups().then((response: any) => {
            this.groups = response;
            this.isBusy = false;
        });
    }
}
